import React, { FC, useEffect, useRef, useState } from 'react';
import Styles from './ProductDetailsV3.module.scss';
import RichText from '../richtext';
import ToolTip from '../ToolTip/ToolTip';
import { AssetPathPropConfig } from '../../services/LineTableBasicPropConfig';
import { getElementMaximumHeight } from '../../utils/utils';
import CountryOverlays from '../CountryOverlays/CountryOverlays';

const ProductEntitlement: FC<any> = ({
  content,
  entitlementConfig,
  indexKey,
  listlength,
  showModalPopup,
  sbStaticConstants,
  tabIndex,
  countryList,
  metadata
}): any => {
  const [showMore, setShowMore] = useState(false);
  const entitlementSection = useRef<HTMLDivElement>(null);
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();

  useEffect(() => {
    setTimeout(() => {
      findHeight();
    }, 100);
  }, [showMore]);

  const findHeight = () => {
    getElementMaximumHeight('product-configv3' + `${tabIndex}`, listlength);
    getElementMaximumHeight('detailsectionv3' + `${tabIndex}`, listlength);
  };

  return (
    <div ref={entitlementSection}>
      <div className={Styles.productdetailswrapper}>
        <div className={Styles.configheadersection} style={{ width: '100%' }}>
          {content?.icon ? (
            <span>
              <img
                src={content?.icon}
                alt='img'
                width={24}
                height={24}
                className={Styles.imagecontainer}
              />
            </span>
          ) : (
            ''
          )}

          <span className={Styles.displayname}>{content?.name}</span>
          {content?.tooltip ? (
            <div className={Styles.bundletooltip} style={{ marginLeft: 'auto' }}>
              <ToolTip content={content?.tooltip} />
            </div>
          ) : (
            ''
          )}
        </div>
        <div className={Styles.configdetailssection}>
          {content?.tvChannelName && content?.poType === 'TV' && (
            <div
              className={Styles.newmodal}
              onClick={() => {
                showModalPopup();
              }}
            >
              <div className={Styles.tvHeading}>{content?.tvChannelName}</div>

              <div className={Styles.changeBtn}>{sbStaticConstants.changeText}</div>
              <img
                src={`${assetPath}/icons/chevron-down-red.svg`}
                height={24}
                width={24}
                alt={''}
              />
            </div>
          )}
          {content?.includeDescription ? (
            <div className={Styles.productdetailsdescription} id={`entitledespV3${indexKey}`}>
              <RichText content={content?.description} />
            </div>
          ) : (
            <>
              {content?.includeEntitlement &&
                entitlementConfig &&
                entitlementConfig?.map((entitlementValues: any, index: number) => {
                  return (
                    <>
                      {index < 2 || (index > 1 && showMore) ? (
                        <div className={Styles.entitlementvalue}>
                          {entitlementValues?.icon && (
                            <div className={Styles.entitlementicon}>
                              <img src={entitlementValues?.icon} width={20} height={20} alt='entitlementicon'/>
                            </div>
                          )}
                          <div className={entitlementValues?.isDisabled ? Styles.disabled : ''}>
                            {entitlementValues?.entitlement}
                            {entitlementValues?.toolTipText && (
                              <div className={Styles.bundletooltip}>
                                <ToolTip content={entitlementValues?.toolTipText} />
                              </div>
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                    </>
                  );
                })}
              {entitlementConfig?.length > 2 && (
                <div className={Styles.showmore} onClick={() => setShowMore(!showMore)}>
                  {!showMore ? sbStaticConstants?.show_more : sbStaticConstants?.show_less}
                </div>
              )}
            </>
          )}
          {content?.linkText && (
            <CountryOverlays
              product={countryList}
              linkText={content?.linkText}
              metadata={metadata}
              reuseableLineTable={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export default ProductEntitlement;
